import React from 'react'
const iconColor = 'rgba(0, 0, 0, 0.54)'

export const ClubsBagIcon = ({ color = iconColor, size = 24 }) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipPath="url(#clip0_2_7807)"
      d="M13.8429 9.35181L18.9078 4.28695L20.3991 5.7783C21.2214 6.6006 22.5594 6.60065 23.3818 5.7783C24.206 4.95412 24.2061 3.62001 23.3818 2.79565L22.3876 1.80139C21.5652 0.979037 20.2272 0.979083 19.4049 1.80139L12.8486 8.3576L11.8544 7.36333C12.6186 6.59915 13.7405 5.47726 14.6212 4.59656C15.4435 3.77426 15.4435 2.43622 14.6212 1.61391L13.6269 0.619651C12.8046 -0.202652 11.4666 -0.202652 10.6442 0.619698C9.82195 1.442 9.82195 2.77999 10.6442 3.60234H10.6442L12.1356 5.09369C11.597 5.63225 10.0147 7.21462 9.5047 7.72459C9.38176 7.2621 9.14006 6.82491 8.778 6.46285C7.67899 5.36393 5.9002 5.36375 4.80109 6.46285L0.824138 10.4398C-0.274735 11.5385 -0.275016 13.3175 0.824138 14.4167C1.17898 14.7715 1.61213 15.0191 2.08438 15.1449L0.208899 17.0205C-0.0714672 17.3008 -0.0646244 17.7583 0.22474 18.0301L6.37755 23.8079C6.65295 24.0665 7.08611 24.0624 7.35593 23.7926C9.00546 22.143 16.1009 15.0476 17.3226 13.8258C17.5972 13.5513 17.5972 13.1061 17.3226 12.8316L15.8313 11.3402L16.9192 10.2523L18.4106 11.7436C19.2329 12.5659 20.5709 12.566 21.3933 11.7436C22.2176 10.9194 22.2177 9.58536 21.3933 8.76094L20.3991 7.76677C19.5767 6.94442 18.2387 6.94447 17.4164 7.76677C17.1783 8.00486 15.1022 10.081 14.8371 10.3461L13.8429 9.35181ZM21.3933 2.7956L22.3876 3.78986C22.6623 4.06465 22.6623 4.50924 22.3876 4.78408C22.1135 5.05817 21.6674 5.05817 21.3933 4.78408L19.902 3.29273L20.3991 2.7956C20.6732 2.52156 21.1192 2.52147 21.3933 2.7956ZM19.4049 8.76099L20.3991 9.75521C20.6739 10.03 20.6739 10.4746 20.3991 10.7494C20.1249 11.0236 19.679 11.0235 19.4049 10.7494L17.9136 9.25807L18.4106 8.76094C18.6848 8.48691 19.1308 8.48686 19.4049 8.76099ZM13.1299 4.09948L11.6385 2.60818C11.3644 2.33404 11.3644 1.88805 11.6385 1.61396C11.9127 1.33983 12.3587 1.33983 12.6328 1.61396L13.627 2.60818C13.9011 2.88231 13.9011 3.32831 13.627 3.60239L13.1299 4.09948ZM3.80688 13.4225C3.2574 13.9719 2.36802 13.972 1.8184 13.4225C1.27023 12.8742 1.27023 11.9822 1.8184 11.434L5.79536 7.45712C6.34484 6.90763 7.23421 6.90759 7.78384 7.45712C8.33177 8.0051 8.33201 8.89649 7.78458 9.4448L3.80707 13.4223C3.80702 13.4224 3.80693 13.4224 3.80688 13.4225ZM12.7549 16.4052L10.7665 14.4167L11.7607 13.4225L13.7492 15.4109L12.7549 16.4052ZM9.77227 15.4109L11.7607 17.3994L8.77805 20.3821L6.78957 18.3936L9.77227 15.4109ZM14.7434 14.4167L12.2578 11.9311C11.9833 11.6566 11.5382 11.6566 11.2636 11.9311L5.29827 17.8965C5.02372 18.171 5.02372 18.6161 5.29827 18.8907L7.78384 21.3762L6.84347 22.3166L1.71609 17.5017C2.28469 16.9331 10.3266 8.89114 10.8602 8.3576L15.8313 13.3287L14.7434 14.4167Z"
      fill={color}
    />
    <defs>
      <clipPath id="clip0_2_7807">
        <rect width={`${size}px`} height={`${size}px`} fill={color} />
      </clipPath>
    </defs>
  </svg>
)
export const ShirtSizeIcon = ({ color = iconColor, size = 24 }) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.6 15.2L12 8.75004V7.84004C13.65 7.35004 14.8 5.67004 14.43 3.79004C14.17 2.48004 13.13 1.39004 11.82 1.09004C9.54002 0.570036 7.50002 2.30004 7.50002 4.50004H9.50002C9.50002 3.67004 10.17 3.00004 11 3.00004C11.83 3.00004 12.5 3.67004 12.5 4.50004C12.5 5.34004 11.81 6.02004 10.97 6.00004C10.43 5.99004 10 6.45004 10 6.99004V8.75004L1.40002 15.2C0.630015 15.78 1.04002 17 2.00002 17H11H20C20.96 17 21.37 15.78 20.6 15.2ZM5.00002 15L11 10.5L17 15H5.00002Z"
      fill={color}
    />
  </svg>
)
export const CrossedClubsIcon = ({ color = iconColor, size = 24 }) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8664 17.2393L21.3616 16.0796C21.1777 15.6585 20.8263 15.3423 20.3976 15.2105C19.9664 15.0773 19.5034 15.14 19.1254 15.3884L15.196 17.942L12.6656 12.4802L16.3464 4.52993L15.8048 4.26625L15.262 4L11.9997 11.0427L8.73876 4L7.65177 4.52993L11.3338 12.4802L8.80472 17.942L4.87532 15.3897C4.4948 15.14 4.03185 15.0773 3.60187 15.2105C3.17316 15.3423 2.82183 15.6585 2.64045 16.0783L2.1331 17.2393C1.79191 18.0214 2.1293 18.9571 2.88651 19.3219L5.81518 20.7338C6.19061 20.9142 6.58508 21 6.97573 21C8.00438 21 8.99498 20.4061 9.46427 19.391L12.001 13.9176L14.5352 19.391C15.0058 20.4048 15.9951 21 17.025 21C17.4144 21 17.8101 20.9142 18.1856 20.7325L21.1117 19.3232C21.8702 18.9571 22.2088 18.0214 21.8664 17.2393Z"
      fill={color}
    />
  </svg>
)
export const HandednessIcon = ({ color = iconColor, size = 24 }) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipPath="url(#clip1_319_11317)"
      d="M18.5 8C18.33 8 18.16 8.02 18 8.05V4.5C18 3.12 16.88 2 15.5 2C15.31 2 15.13 2.02 14.96 2.06C14.75 0.89 13.73 0 12.5 0C11.44 0 10.54 0.66 10.17 1.59C9.96 1.53 9.73 1.5 9.5 1.5C8.12 1.5 7 2.62 7 4V4.55C6.84 4.52 6.67 4.5 6.5 4.5C5.12 4.5 4 5.62 4 7V15.5C4 20.19 7.81 24 12.5 24C17.19 24 21 20.19 21 15.5V10.5C21 9.12 19.88 8 18.5 8ZM19 15.5C19 19.09 16.09 22 12.5 22C8.91 22 6 19.09 6 15.5V7C6 6.72 6.22 6.5 6.5 6.5C6.78 6.5 7 6.72 7 7V12H9V4C9 3.72 9.22 3.5 9.5 3.5C9.78 3.5 10 3.72 10 4V11H12V2.5C12 2.22 12.22 2 12.5 2C12.78 2 13 2.22 13 2.5V11H15V4.5C15 4.22 15.22 4 15.5 4C15.78 4 16 4.22 16 4.5V13.42C14.23 14.19 13 15.95 13 18H15C15 16.34 16.34 15 18 15V10.5C18 10.22 18.22 10 18.5 10C18.78 10 19 10.22 19 10.5V15.5Z"
      fill={color}
    />
    <defs>
      <clipPath id="clip0_319_11317">
        <rect width={`${size}px`} height={`${size}px`} fill={color} />
      </clipPath>
      <clipPath id="clip1_319_11317">
        <rect width={`${size}px`} height={`${size}px`} fill={color} />
      </clipPath>
    </defs>
  </svg>
)
